import { ComponentType } from "react";

export const withIdInputField = <T,>(InputComponent: ComponentType<T>) => {
    const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
    };

    return (props: T) => {
        return <InputComponent {...props} onInput={onInput} />;
    };
};
